import {Component, Input, OnChanges} from '@angular/core';
import {FirebaseService} from '../app/firebase.service';
import {Zahlung} from '../app/types';
import {User} from '../app/user';

@Component({
  selector: 'app-kunde-zahlungen',
  templateUrl: './kunde-zahlungen.component.html',
  styles: []
})
export class KundeZahlungenComponent implements OnChanges {
  @Input()
  user: User;
  @Input()
  admin: boolean;
  zahlungen: Zahlung[];

  constructor(public service: FirebaseService) { }

  ngOnChanges() {
    if (!this.user) {
      this.zahlungen = null;
      return;
    }
    this.user.zahlungen.subscribe(zahlungen => {
      this.zahlungen = zahlungen;
    });
  }
}
